import React from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { CasesTable, PrivateLayout } from '../components';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { navigateToServiceRequest } from '../redux';

export const CasesView = () => {
  const dispatch = useDispatch();

  const renderButton = () => {
    return (
      <FeatureGuard contentKey='service-request.manage'>
        <Button variant='secondary' size='sm' onClick={() => dispatch(navigateToServiceRequest())}>
          START A NEW REQUEST
        </Button>
      </FeatureGuard>
    );
  };

  return (
    <PrivateLayout pageTitle='Cases' subtoolbarChildren={renderButton()}>
      <h5>Below is a list of your cases.</h5>
      <CasesTable enableExternalFilters />
    </PrivateLayout>
  );
};
